import { combineReducers } from 'redux'
import authentication from './authentication/reducer'
import signUp from './sign-up/reducer'
import process from './process/reducer'
import snackbar from './snackbar/reducer'
import messageBox from './message-box/reducer'
import componentBox from './component-box/reducer'
import operation from './operation/reducer'
import common from './common/reducer'
import card from './card/reducer'
import user from './user/reducer'
import shop from './shop/reducer'
import userPassword from './user-password/reducer'
import mediaDirectory from './media-directory/reducer'
import mediaFolder from './media-folder/reducer'
import mediaImage from './media-image/reducer'
import mediaVideo from './media-video/reducer'
import settings from './settings/reducer'
import course from './course/reducer'
import domain from './domain/reducer'
import courseTimeSeries from './course-time-series/reducer'
import courseStatistics from './course-statistics/reducer'
import userRoleDetailedList from './user-role-detailed-list/reducer'
import courseCollectionList from './course-collection/reducer'
import teamsList from './teams/reducer'
import llmContent from './llm/reducer'
import certificate from './certificate/reducer'
import aICreator from './ai-creator/reducer'
import collection from './collection/reducer'
import userLimits from './user-limits/reducer'
import localizations from './localizations/reducer'
import marketing from './marketing/reducer'
import scorm from './scorm/reducer'
import tag from './tag/reducer'
const rootReducer = combineReducers({
  authentication,
  process,
  snackbar,
  messageBox,
  componentBox,
  operation,
  common,
  card,
  user,
  shop,
  userPassword,
  signUp,
  mediaDirectory,
  mediaFolder,
  mediaImage,
  mediaVideo,
  settings,
  course,
  domain,
  courseTimeSeries,
  courseStatistics,
  userRoleDetailedList,
  courseCollectionList,
  teamsList,
  llmContent,
  certificate,
  aICreator,
  collection,
  userLimits,
  localizations,
  marketing,
  scorm,
  tag,
})

export default rootReducer
